// ==========================================
// Footer.jsx - Bottom Information
// ==========================================

import React from "react";
import styles from "../assets/styles/Footer.module.css";

function Footer() {
  return (
    <footer className={styles.footer}>
      <p>
        &copy; 2025 FormForge - Form Ideation App | All rights reserved.
        <br />
        Credits:{" "}
        <a
          href="https://www.linkedin.com/in/sankar4/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Sankar Balasubramanian & Amogh A S
        </a>
      </p>
    </footer>
  );
}

export default Footer;
// ==========================================
